import Overlay from 'Components/Overlay';
import React from 'react';
import Moment from 'moment';
import { Table } from 'reactstrap';

const formatDate = (value) => (value ? Moment(value).format('DD MMM YYYY, hh:mm A') : '-');

// upload-td-th / upload-th default to 18px; keep this popup compact
const cellStyle = { fontSize: '13px', padding: '6px 10px' };

const LppValuesPopup = ({ lppValues, trip, onCancel }) => {
    const values = lppValues || [];
    return (
        <Overlay>
            <div className="tCenter">
                <div className="mb-10 tCenter fSemibold fs-18 mt-10 mb-5">LPP Details</div>
                {trip && <div className="fs-13 label-color mb-10">{trip.from} → {trip.to}</div>}
                <section className="overflowAuto status-table-height ph-20 pv-10" style={{ width: '800px' }}>
                    {values.length > 0 ?
                        <Table striped className="upload-rfq-table col-1 fs-13 mb-20 br-5" responsive bordered>
                            <thead>
                                <tr>
                                    <th className='upload-td-th upload-th' style={cellStyle}>Vehicle Type</th>
                                    <th className='upload-td-th upload-th' style={cellStyle}>Vehicle Body Type</th>
                                    <th className='upload-td-th upload-th' style={cellStyle}>LPP</th>
                                    <th className='upload-td-th upload-th' style={cellStyle}>Pricing Basis</th>
                                    <th className='upload-td-th upload-th' style={cellStyle}>LPP Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {values.map((item, index) => {
                                    const rowStyle = { ...cellStyle, 'backgroundColor': (index % 2 === 1) ? '#EFF2FD' : 'white' };
                                    return (
                                        <tr key={index}>
                                            <td className="upload-td-th" style={rowStyle}>{item.vehicle_type || '-'}</td>
                                            <td className="upload-td-th" style={rowStyle}>{item.vehicle_body_type || '-'}</td>
                                            <td className="upload-td-th" style={rowStyle}>{(item.lpp || item.lpp === 0) ? `₹ ${item.lpp}` : '-'}</td>
                                            <td className="upload-td-th" style={rowStyle}>{item.pricing_basis || '-'}</td>
                                            <td className="upload-td-th" style={rowStyle}>{formatDate(item.inserted_on)}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </Table>
                        :
                        <div className="fs-13 label-color pv-20">No LPP details found</div>
                    }
                </section>
                <div className="col-1 ht-60 flex flex-middle flex-center">
                    <button className="ht-40 br-5 theme-color border-theme fs-16 fBold wt-150" onClick={onCancel}>Close</button>
                </div>
            </div>
        </Overlay>
    );
};

export default LppValuesPopup;
